import dayjs from "dayjs";

const dateStart = dayjs(new Date())
	.set('hour', 0)
	.set('minute', 0)
	.set('second', 0)
	.format('YYYY/MM/DD HH:mm:ss');

const dateEnd = dayjs(new Date())
	.set('hour', 23)
	.set('minute', 59)
	.set('second', 59)
  .format('YYYY/MM/DD HH:mm:ss');
  
const INIT_SETTINGS = {
	detector: [
		{
			text: 'selectImagesFromCloud',
			settingContent: false,
			type: 'toggle',
			key: 'detector_select_images_from_cloud',
		},

		{
			text: 'autoCloseDetectedImage',
			settingContent: true,
			type: 'toggle',
			key: 'detector_auto_close_detected_image',
		},
		{
			text: 'setDefaultDate',
			settingContent: [dateStart, dateEnd],
			type: 'date',
			key: 'detector_default_date',
		},
		// Allow changing model when selecting images
		{
			text: 'allowChangeModel',
			settingContent: false,
			type: 'toggle',
			key: 'detector_allow_changing_model',
		},
		{
			text: 'selectedCamera',
			settingContent: '',
			type: 'select',
			key: 'selected_camera',
		},
	],
};

export { INIT_SETTINGS };
